import i18n from '@/main';
import http from '@/utils/http';
import axios from 'axios';

const URL_BASE = '/contrato-originacao';
const URL_BASE_TERRITORIO = '/territorios';
const URL_BASE_GERENTE_TERRITORIAL = URL_BASE + '/gerente-territorial';
const URL_BASE_GERENTE_COMERCIAL = URL_BASE + '/gerente-comercial';
const URL_BASE_GERENTE_REGIONAL = URL_BASE + '/gerente-regional';
const URL_BASE_REGIONAL = '/regional';

export default {
    buscarRegionais() {
        return http.get({
            url: URL_BASE_REGIONAL,
            lockScreen: false
        });
    },

    buscarGerentesComerciais() {
        return http.get({
            url: URL_BASE_GERENTE_COMERCIAL,
            lockScreen: false
        });
    },

    buscarGerentesRegionais() {
        return http.get({
            url: URL_BASE_GERENTE_REGIONAL,
            lockScreen: false
        });
    },

    buscarContratosNaoEnviados({ pagina, ordenacao, tamanho }) {
        return http.get({
            url:
                URL_BASE +
                `/empresa/nao-enviados?page=${
                    pagina - 1
                }&sort=${ordenacao}&size=${tamanho}`,
            lockScreen: false
        });
    },

    buscarContratoOriginacao(id) {
        return http.get({
            url: URL_BASE + '/empresa/visualizar/' + id,
            lockScreen: true
        });
    },

    buscarTodosContratos() {
        return http.post({
            url: URL_BASE + '/empresa',
            lockScreen: true
        });
    },

    buscarDetalheAnalise(numeroContrato, idTerritorio) {
        return http.get({
            url:
                URL_BASE +
                '/subempresa/detalhe-analise/' +
                numeroContrato +
                '/' +
                idTerritorio,
            lockScreen: true
        });
    },

    buscarCulturas() {
        return http.get({
            url: URL_BASE + '/material',
            lockScreen: false
        });
    },

    buscarSafras() {
        return http.get({
            url: URL_BASE + '/safra',
            lockScreen: false
        });
    },

    buscarBpClientes() {
        return http.get({
            url: URL_BASE + '/fornecedor-parceiro',
            lockScreen: false
        });
    },

    buscarFornecedores() {
        return http.get({
            url: '/fornecedor',
            lockScreen: false
        });
    },

    buscarCnpjFornecedores() {
        return [
            {
                label: 'CRIAR BACKEND',
                valor: 1
            }
        ];
    },

    buscarSegmentos() {
        return http.get({
            url: URL_BASE + '/segmento',
            lockScreen: false
        });
    },

    buscarCanais() {
        return http.get({
            url: URL_BASE + '/canal',
            lockScreen: false
        });
    },

    buscarStatus() {
        return http.get({
            url: URL_BASE + '/empresa/status',
            lockScreen: false
        });
    },

    buscarClientes() {
        return http.get({
            url: URL_BASE + '/clientes',
            lockScreen: false
        });
    },
    buscarGerentesTerritoriais() {
        return http.get({
            url: URL_BASE_GERENTE_TERRITORIAL,
            lockScreen: false
        });
    },

    cadastrarManualmente({
        numeroContrato,
        idMaterial,
        idSafra,
        volumeContratado,
        volumeRecebido,
        valorDataContrato,
        idBpCliente,
        idSubEmpresa,
        subEmpresaCnpj,
        idSegmento,
        idCanal,
        idRegional,
        idMunicipio,
        idGerenteComercial,
        idGestorTerritorial,
        idGerenteRegional,
        tipoContratoOffline
    }) {
        return http.post({
            url: URL_BASE + '/empresa/inserir',
            data: {
                numeroContrato,
                idMaterial,
                idSafra,
                volumeContratado,
                volumeRecebido,
                valorDataContrato,
                idBpCliente,
                idSubEmpresa,
                subEmpresaCnpj,
                idSegmento,
                idCanal,
                idRegional,
                idMunicipio,
                idGerenteComercial,
                idGestorTerritorial,
                idGerenteRegional,
                tipoContratoOffline
            },
            lockScreen: false
        });
    },

    cadastrarViaPlanilha(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/empresa/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    cadastrarTerritoriosViaPlanilha(planilha, numeroContrato) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${URL_BASE}/subempresa/inserir-planilha/${numeroContrato}`;

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    enviarContratos() {
        return http.get({
            url: URL_BASE + '/empresa/enviar-contratos',
            lockScreen: true
        });
    },

    dadosContratoSubempresa(numeroContrato) {
        return http.get({
            url: URL_BASE + '/subempresa/dados-gerais/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosGeraisDeContratos'
            )
        });
    },

    inserirDadosContrato(data) {
        return http.post({
            url: URL_BASE + '/subempresa/inserir',
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoDadosDeContrato')
        });
    },

    findAll(search, lockScreen = true) {
        return http.get({
            url:
                URL_BASE_TERRITORIO +
                `/buscaTerritorioPaginado?searchText=${search}`,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarVisualizarProcessamentoSubEmpresa({ numeroContrato }) {
        return http.get({
            url: URL_BASE + `/subempresa/visualizar/${numeroContrato}`,
            lockScreen: true
        });
    },

    buscarTerritoriosVisualizarProcessamentoContratoSubEmpresa({
        contrato,
        pagina,
        tamanho,
        buscarTerritoriosComRestricao
    }) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/${contrato}?page=${pagina}&size=${tamanho}&territoriosComRestricoes=${buscarTerritoriosComRestricao}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarDadosContratosOriginacao({
        numeroContrato,
        page,
        size,
        territoriosComRestricoes
    }) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/${numeroContrato}?page=${page}&size=${size}&territoriosComRestricoes=${territoriosComRestricoes}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeContrato')
        });
    },

    removerTerritorioContratoSubEmpresa(numeroContrato, idTerritorio) {
        return http.post({
            url:
                URL_BASE +
                `/subempresa/remover/${numeroContrato}/${idTerritorio}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    concluirProcessamentoContratoSubempresa({ contrato }) {
        return http.get({
            url: URL_BASE + `/subempresa/concluir-processamento/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },

    exportarRelatorioContratoEmpresa(numeroContrato) {
        return http.get({
            url: URL_BASE + `/empresa/exportar-relatorio/${numeroContrato}`,
            lockScreen: false
        });
    },

    exportarRelatorioContratoEmpresaPY(numeroContrato) {
        return http.get({
            url: URL_BASE + `/empresa/exportar-relatorio-py/${numeroContrato}`,
            lockScreen: false
        });
    },

    exportarRelatorioContratoSubempresa(numeroContrato, listarTerritorios) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/exportar-relatorio/${numeroContrato}?listarTerritorios=${listarTerritorios}`,
            lockScreen: false
        });
    },

    buscarDadosLoteEmpresa() {
        return http.get({
            url: URL_BASE + '/empresa/lote',
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url:
                        URL_BASE + `/empresa/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    _buscarCpfCnpjFornecedor(id) {
        return http.get({
            url: `/fornecedor/${id}/cpfcnpj`,
            lockScreen: false
        });
    },

    inserirTerritorio(data) {
        return http.post({
            url: URL_BASE + `/subempresa/territorio/inserir`,
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.inserindoTerritorio')
        });
    },

    downloadPlanilhaComErroSubEmpresa(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url:
                        URL_BASE +
                        `/subempresa/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarStatusSubempresa() {
        return http.get({
            url: URL_BASE + '/empresa/subempresa/status',
            lockScreen: false
        });
    },

    buscarFornecedoresPorFiltro(filtro, pageable) {
        return http.post({
            url: `${URL_BASE}/fornecedor-parceiro/filtro?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sort},${pageable.order}`,
            data: filtro,
            lockScreen: true
        });
    },

    buscarGerentesTerritoriaisPorFiltro(filtro, pageable) {
        return http.post({
            url: `${URL_BASE_GERENTE_TERRITORIAL}/filtro?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sort},${pageable.order}`,
            data: filtro,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    buscarGerentesComercialPorFiltro({ filtro, pageable }) {
        const { page, size, sort, order } = pageable;

        return http.post({
            url: `${URL_BASE_GERENTE_COMERCIAL}/filtro?page=${page}&size=${size}&sort=${sort},${order}`,
            data: filtro,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    buscarGerentesRegionalPorFiltro({ filtro, pageable }) {
        const { page, size, sort, order } = pageable;

        return http.post({
            url: `${URL_BASE_GERENTE_REGIONAL}/filtro?page=${page}&size=${size}&sort=${sort},${order}`,
            data: filtro,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    buscarRegionalPorFiltro({ filtro, pageable }) {
        const { page, size, sort, order } = pageable;

        return http.post({
            url: `${URL_BASE_REGIONAL}/filtro?page=${page}&size=${size}&sort=${sort},${order}`,
            data: filtro,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    cadastrarFornecedor(input) {
        return http.post({
            url: `${URL_BASE}/fornecedor-parceiro/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    editarFornecedor(input) {
        return http.post({
            url: `${URL_BASE}/fornecedor-parceiro/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    removerFornecedor(input) {
        return http.post({
            url: `${URL_BASE}/fornecedor-parceiro/remover`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    cadastrarGerenteTerritorial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_TERRITORIAL}/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    editarGerenteTerritorial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_TERRITORIAL}/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    removerGerenteTerritorial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_TERRITORIAL}/remover`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    cadastrarGerenteComercial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_COMERCIAL}/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    editarGerenteComercial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_COMERCIAL}/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    removerGerenteComercial(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_COMERCIAL}/remover`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    cadastrarGerenteRegional(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_REGIONAL}/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    editarGerenteRegional(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_REGIONAL}/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    removerGerenteRegional(input) {
        return http.post({
            url: `${URL_BASE_GERENTE_REGIONAL}/remover`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    cadastraRegional(input) {
        return http.post({
            url: `${URL_BASE_REGIONAL}/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    editaRegional(input) {
        return http.post({
            url: `${URL_BASE_REGIONAL}/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },
    removeRegional(input) {
        return http.post({
            url: `${URL_BASE_REGIONAL}/remover`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    exportarRelatorioXlsx(filtro) {
        return http.post({
            url: URL_BASE + `/empresa/exportar-relatorio`,
            data: {
                filtro
            },
            lockScreen: false
        });
    },

    buscarMateriaisPorFiltro(filtro, pageable) {
        return http.post({
            url: `${URL_BASE}/material/filtro?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sort},${pageable.order}`,
            data: filtro,
            lockScreen: true
        });
    },

    cadastrarMaterial(input) {
        return http.post({
            url: `${URL_BASE}/material/cadastrar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    buscarMaterial(id) {
        return http.get({
            url: `${URL_BASE}/material/buscar?id=` + id,
            lockScreen: true
        });
    },

    editarMaterial(input) {
        return http.post({
            url: `${URL_BASE}/material/editar`,
            data: input,
            lockScreen: true,
            notify: {
                status: [500]
            }
        });
    },

    exportarPdfRelatorioRastreabilidadeEmpresa(numeroContrato) {
        return http.get({
            url:
                URL_BASE +
                `/empresa/exportar-pdf-relatorio-rastreabilidade/${numeroContrato}`,
            lockScreen: false
        });
    },

    exportarPdfRelatorioRastreabilidadeSubempresa(numeroContrato) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/exportar-pdf-relatorio-rastreabilidade/${numeroContrato}`,
            lockScreen: false
        });
    },

    compartilharRelatorioRastreabilidadeEmpresa(numeroContrato, email) {
        return http.post({
            url:
                URL_BASE +
                '/empresa/compartilhar-relatorio-rastreabilidade-email',
            data: {
                numeroContrato,
                email
            },
            lockScreen: false
        });
    },

    compartilharRelatorioRastreabilidadeSubempresa(numeroContrato, email) {
        return http.post({
            url:
                URL_BASE +
                '/subempresa/compartilhar-relatorio-rastreabilidade-email',
            data: {
                numeroContrato,
                email
            },
            lockScreen: false
        });
    }
};
